import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getById',
  pure: false
})
export class GetByIdPipe implements PipeTransform
{
  /**
   * Transform
   *
   * @param {any[]} value
   * @param {number|string} id
   * @param {string} property
   * @returns {any}
   */
  transform(value: any[], id: number | string, property: string): any
  {

    const foundItem = value.find(item => {
      if ( item.id !== undefined )
      {
        return item.id === Number(id);
      }

      return false;
    });

    if ( foundItem )
    {
      return foundItem[property];
    }
  }
}
